import React, { memo } from 'react';

interface StarButtonProps {
    starNumber: number;
    isSelected: boolean;
    isHovered: boolean;
    shouldShowYellow: boolean;
    onClick: (e: React.MouseEvent) => void;
    onPointerEnter: (e: React.PointerEvent) => void;
    onPointerLeave: (e: React.PointerEvent) => void;
    buttonStyle: React.CSSProperties;
}

const STAR_PATH = "M36.1951 15.5275C37.3925 11.8423 42.6061 11.8423 43.8035 15.5275L48.0818 28.6947C48.6173 30.3428 50.1531 31.4587 51.886 31.4587H65.7308C69.6057 31.4587 71.2168 36.4171 68.082 38.6947L56.8813 46.8325C55.4793 47.8511 54.8927 49.6565 55.4282 51.3046L59.7065 64.4718C60.9039 68.1571 56.686 71.2216 53.5511 68.944L42.3504 60.8062C40.9485 59.7876 39.0501 59.7876 37.6481 60.8062L26.4475 68.944C23.3126 71.2216 19.0947 68.1571 20.2921 64.4718L24.5704 51.3046C25.1059 49.6565 24.5192 47.8511 23.1173 46.8325L11.9166 38.6947C8.78177 36.4171 10.3929 31.4587 14.2678 31.4587H28.1126C29.8455 31.4587 31.3813 30.3428 31.9168 28.6947L36.1951 15.5275Z";

const SVG_STYLES = {
    filter: 'drop-shadow(0 0 4px rgba(0, 0, 0, 0.04)), drop-shadow(0 8px 16px rgba(0, 0, 0, 0.08))',
};



const StarButton: React.FC<StarButtonProps> = memo(({ starNumber, isHovered, shouldShowYellow, onClick, onPointerEnter, onPointerLeave, buttonStyle }) => {   
    return (
        <button
            type="button"
            onClick={onClick}
            onPointerEnter={onPointerEnter}
            onPointerLeave={onPointerLeave}
            className={`flex-1 aspect-square flex items-center justify-center transition-all duration-200 ${isHovered ? 'scale-110' : ''} cursor-pointer`}
            style={buttonStyle}
        >
            <svg
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-full h-full"
                style={SVG_STYLES}
            >
                <mask id={`mask0_2139_5874_${starNumber}`} maskUnits="userSpaceOnUse" x="0" y="0" width="80" height="80">
                    <rect width="80" height="80" fill="white"/>
                </mask>
                <g mask={`url(#mask0_2139_5874_${starNumber})`}>
                    <path
                        d={STAR_PATH}
                        fill={shouldShowYellow ? '#FFFF00' : 'white'}
                    />
                </g>
            </svg>
        </button>
    );
});

export default StarButton;
